import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/baseLayout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
